export const permissions = {
  // System Management
  ChangeClaimStatus: "ChangeClaimStatus",
  DownloadShippingLabel: "DownloadShippingLabel",
  EditClaimItem: "EditClaimItem",
  EditClaimLocation: "EditClaimLocation",
  EditGuestInformation: "EditGuestInformation",
  NotifyMatch: "NotifyMatch",
  UndoNotifyMatch: "UndoNotifyMatch",
  AddEditTrackingDocs: "AddEditTrackingDocs",
  DeleteTrackingDocs: "DeleteTrackingDocs",
  ApproveDisApproveCustomerEditRequest: "ApproveDisApproveCustomerEditRequest",
  ApproveDisApproveCustomerDeleteRequest: "ApproveDisApproveCustomerDeleteRequest",
  ApproveDisApproveBillingInfoEditRequest: "ApproveDisApproveBillingInfoEditRequest",
  MarkStickyAsDone: "MarkStickyAsDone",
  AllowMarkAsShipped: "AllowMarkAsShipped",
  ViewShippingProof: "ViewShippingProof",
  DeleteShippingProof: "DeleteShippingProof",
  AddEditShippingProof: "AddEditShippingProof",
  ViewFinalMatchColumn: "ViewFinalMatchColumn",
  IsSendEmailTemplate: "IsSendEmailTemplate",
  EditItemColumnLabel: "EditItemColumnLabel",

  // Menu Visibility
  IsDraftsMenuVisible: "IsDraftsMenuVisible",
  IsNotPaidMenuVisible: "IsNotPaidMenuVisible",
  IsLFNotifiedMenuVisible: "IsLFNotifiedMenuVisible",
  IsDeletedLostItemsMenuVisible: "IsDeletedLostItemsMenuVisible",
  IsCustomersMenuVisible: "IsCustomersMenuVisible",
  IsCategoryMenuVisible: "IsCategoryMenuVisible",
  IsPricingPlanMenuVisible: "IsPricingPlanMenuVisible",
  IsEstablishmentTypeMenuVisible: "IsEstablishmentTypeMenuVisible",
  IsUserRoleConfigMenuVisible: "IsUserRoleConfigMenuVisible",
  IsUserMenuVisible: "IsUserMenuVisible",
  IsDeleteLostReasonMenuVisible: "IsDeleteLostReasonMenuVisible",
  IsEmailTemplateMenuVisible: "IsEmailTemplateMenuVisible",
  IsKeyAndSettingMenuVisible: "IsKeyAndSettingMenuVisible",
  IsPermissionConfigMenuVisible: "IsPermissionConfigMenuVisible",
  IsWhiteboardMenuVisible: "IsWhiteboardMenuVisible",
  IsReviewMenuVisible: "IsReviewMenuVisible",

  // Payment Management
  IsPaymentLogAllowed: "IsPaymentLogAllowed",
  ShowPaymentAttachmentInLog: "ShowPaymentAttachmentInLog",

  // Category Management
  ViewCategory: "ViewCategory",
  AddEditCategory: "AddEditCategory",
  AddEditSubCategory: "AddEditSubCategory",
  AddEditQuestion: "AddEditQuestion",
  DeleteSubCategory: "DeleteSubCategory",
  DeleteQuestion: "DeleteQuestion",
  ViewQuestion: "ViewQuestion",
  ViewSubCategory: "ViewSubCategory",
  DeleteCategory: "DeleteCategory",

  // Pricing Plan Management
  AddEditPricingPlan: "AddEditPricingPlan",
  ViewPricingPlan: "ViewPricingPlan",
  DeletePricingPlan: "DeletePricingPlan",
  AddEditFeatures: "AddEditFeatures",
  ViewFeatures: "ViewFeatures",
  DeleteFeatures: "DeleteFeatures",

  // Establishment Type Management
  AddEditEstablishmentType: "AddEditEstablishmentType",
  ViewEstablishmentType: "ViewEstablishmentType",
  DeleteEstablishmentType: "DeleteEstablishmentType",
  AddEditEstablishmentTypeQuestion: "AddEditEstablishmentTypeQuestion",
  ViewEstablishmentTypeQuestion: "ViewEstablishmentTypeQuestion",
  DeleteEstablishmentTypeQuestion: "DeleteEstablishmentTypeQuestion",

  // User & Role Management
  AddEditUsers: "AddEditUsers",
  ViewRoles: "ViewRoles",
  AddEditRoles: "AddEditRoles",
  DeleteRoles: "DeleteRoles",
  ViewUsers: "ViewUsers",
  ExportUsers: "ExportUsers",
  DeleteUsers: "DeleteUsers",

  // Session Management
  ViewUserSessions: "ViewUserSessions",
  ApproveDisApproveSessions: "ApproveDisApproveSessions",
  RevokeUserSession: "RevokeUserSession",

  // Email Template Management
  ViewEmailTemplate: "ViewEmailTemplate",
  AddEditEmailTemplate: "AddEditEmailTemplate",
  DeleteEmailTemplate: "DeleteEmailTemplate",
  SendBulkEmail: "SendBulkEmail",

  // Delete Reason Management
  ViewDeleteReason: "ViewDeleteReason",
  AddEditDeleteReason: "AddEditDeleteReason",
  DeleteDeleteReason: "DeleteDeleteReason",

  // Conversion Tracking
  IsConversionTrackingMenuVisible: "IsConversionTrackingMenuVisible",

  // Status Permissions (Lost Item)
  IsDraftIncompleteStatusEnabled: "IsDraftIncompleteStatusEnabled",
  IsDraftCompletedStatusEnabled: "IsDraftCompletedStatusEnabled",
  IsNotPaidStatusEnabled: "IsNotPaidStatusEnabled",
  IsOpenStatusEnabled: "IsOpenStatusEnabled",
  IsPendingStatusEnabled: "IsPendingStatusEnabled",
  IsReviewStatusEnabled: "IsReviewStatusEnabled",
  IsInProcessStatusEnabled: "IsInProcessStatusEnabled",
  IsLFNotifiedStatusEnabled: "IsLFNotifiedStatusEnabled",
  IsOverdueStatusEnabled: "IsOverdueStatusEnabled",
  IsCloseStatusEnabled: "IsCloseStatusEnabled",

  // Status Permissions (Found Item)
  IsFoundStatusEnabled: "IsFoundStatusEnabled",
  IsPreMatchStatusEnabled: "IsPreMatchStatusEnabled",
  IsFinalMatchStatusEnabled: "IsFinalMatchStatusEnabled",
  IsReadyToShipStatusEnabled: "IsReadyToShipStatusEnabled",
  IsShippedStatusEnabled: "IsShippedStatusEnabled",
  IsDiscardStatusEnabled: "IsDiscardStatusEnabled",
};
